
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/your-first-moot",
      function () {
        return require("private-next-pages/resources/your-first-moot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/your-first-moot"])
      });
    }
  